export default __webpack_public_path__ + "static/media/transferred.7b220898.png";